import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from 'sweetalert2';
import "../../scss/card.css"
import { CModal } from '@coreui/react';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionSubtopicMaster = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const sectionMasterId = localStorage.getItem("sectionMasterId")
    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        sectionSyllabusStructureMasterId: '',
        sectionLessonMasterId: '',
        sectionTopicMasterId: '',
        sectionSubTopicName: '',
        details: '',
        instituteSubjectMasterId: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);
    const [subTopicNameSort, setSubTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "sectionLessonMasterDetails.sectionLessonName", "sectionTopicMasterDetails.sectionTopicName", "sectionSubTopicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getSubtopicList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (subtopicData.sectionSyllabusStructureMasterId.length !== 0 && subtopicData.instituteSubjectMasterId !== '') {
                setSubtopicList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subtopicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(subtopicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subtopicList.length) {
            endIndex = subtopicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(subtopicList.slice(startIndex, endIndex));
    }, [subtopicList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;

        if (subtopicData.sectionSyllabusStructureMasterId) {
            apiUrl += `sectionSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&`;
        }

        if (subtopicData.sectionLessonMasterId) {
            apiUrl += `sectionLessonMasterId=${subtopicData.sectionLessonMasterId}&`;
        }

        if (subtopicData.sectionTopicMasterId) {
            apiUrl += `sectionTopicMasterId=${subtopicData.sectionTopicMasterId}&`;
        }

        if (subtopicData.instituteSubjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        getSubtopicList();
    }, [subtopicData.instituteSubjectMasterId, subtopicData.sectionLessonMasterId, subtopicData.sectionTopicMasterId]);

    const getSubtopicList = async () => {
        if (subtopicData.sectionSyllabusStructureMasterId !== '' && subtopicData.instituteSubjectMasterId !== '') {
            try {
                const response = await authorizedAxiosSection.get(getApiUrl());
                setSubtopicList(response.data.result);
            } catch (error) {
                setSubtopicList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleDetailChange = (editor) => {
        let value = editor.getData();
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                details: value
            }
        })
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-section-syllabus-structure?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: '',
                sectionLessonMasterId: '',
                sectionTopicMasterId: ''
            }
        })

        const apiUrl = `/get-section-syllabus-structure-Wise-section-subjects?id=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                sectionLessonMasterId: '',
                sectionTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                sectionTopicMasterId: ''
            }
        })
        const apiUrl = `/get-section-lesson-wise-section-sub-topic?id=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(subtopicData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [subtopicData])

    const addTopic = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-section-sub-topic-master`;
                const response = await authorizedAxiosSection.post(apiUrl, subtopicData);
                await getSubtopicList();
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        sectionSubTopicName: '',
                        details: ''
                    }
                })

                setSaveId(response.data.result[0].id);
                setSyllabusStructureNameSort(null);
                setSubjectSort(null);
                setLessonNameSort(null);
                setTopicNameSort(null);
                setSubTopicNameSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteSubtopic = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-section-sub-topic-master?id=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, subtopicList.length);
                await getSubtopicList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateSubtopic = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-section-sub-topic-master?id=${editId}`;
            const response = await authorizedAxiosSection.put(apiUrl, subtopicData);
            await getSubtopicList();
            setSaveId(response.data.result[0].id);
            setEditId(null);
            setSubtopicData((prevData) => {
                return {
                    ...prevData,
                    sectionSubTopicName: '',
                    details: ''
                }
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    setLoading(true);
                    loader.file.then((file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err?.response?.data?.error);
                            })
                            .finally(() => {
                                setLoading(false); // End loading
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setSubTopicNameSort(null);
        }
    }, [topicNameSort])

    useEffect(() => {
        if (subTopicNameSort == true || subTopicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
        }
    }, [subTopicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Sub Topic</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-info"></i> Sub Topic Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionSyllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.sectionSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.sectionSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.sectionSyllabusStructureMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={subtopicData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionLessonMasterId' onChange={handleLessonChange} value={subtopicData.sectionLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.sectionLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionLessonMasterId && <p style={{ color: 'red' }}>{error.sectionLessonMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionTopicMasterId' onChange={handleInputChange} value={subtopicData.sectionTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.sectionTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionTopicMasterId && <p style={{ color: 'red' }}>{error.sectionTopicMasterId}</p>}
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Sub Topic Name :</label>
                                                    <input required type="text" className="form-control" id="sectionSubTopicName" name='sectionSubTopicName' onChange={handleInputChange} value={subtopicData.sectionSubTopicName} />
                                                    {error.sectionSubTopicName && <p style={{ color: 'red' }}>{error.sectionSubTopicName}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Sub Topic Details :</label>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={subtopicData.details}
                                                        onReady={editor => {
                                                            console.log('Editor is ready to use!', editor);
                                                        }}
                                                        onChange={(event, editor) => {
                                                            handleDetailChange(editor)
                                                        }}
                                                        config={{
                                                            extraPlugins: [uploadPlugin],
                                                        }}
                                                        onInit={(editor) => {
                                                            uploadPlugin(editor);
                                                        }}
                                                    />
                                                    {error.details && <p style={{ color: 'red' }}>{error.details}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addTopic}>Save</button>
                                                    }
                                                    <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => { setSubtopicData(initialFormState); setEditId(''); setSubtopicList([]) }}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSubtopic} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    onIni
                                                >
                                                    <div className="book book-modal">
                                                        <div className='table-header-like'> Sub Topic Details</div>
                                                        <div className="page" dangerouslySetInnerHTML={{ __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>` }}></div>
                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>


                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Structure Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"sectionLessonMasterDetails.sectionLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"sectionTopicMasterDetails.sectionTopicName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Sub Topic Name
                                                                            <SortIcon sortState={subTopicNameSort} setSortState={setSubTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"sectionSubTopicName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((subtopic, index) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{subtopic?.sectionSyllabusStructureMasterDetails?.sectionSyllabusStructureName}</td>
                                                                                        <td>{subtopic?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{subtopic?.sectionLessonMasterDetails?.sectionLessonName}</td>
                                                                                        <td>{subtopic?.sectionTopicMasterDetails?.sectionTopicName}</td>
                                                                                        <td>{subtopic?.sectionSubTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setSubtopicData({
                                                                                                    instituteMasterId: instituteMasterId,
                                                                                                    sectionMasterId: sectionMasterId,
                                                                                                    subTopicNo: subtopic.subTopicNo,
                                                                                                    details: subtopic.details,
                                                                                                    sectionSubTopicName: subtopic.sectionSubTopicName,
                                                                                                    sectionLessonMasterId: subtopic.sectionLessonMasterDetails?.id,
                                                                                                    sectionTopicMasterId: subtopic.sectionTopicMasterDetails?.id,
                                                                                                    sectionSyllabusStructureMasterId: subtopic.sectionSyllabusStructureMasterDetails?.id,
                                                                                                    instituteSubjectMasterId: subtopic.instituteSubjectMasterDetails.id
                                                                                                });
                                                                                                setEditId(subtopic.id);
                                                                                                setTopicList([{
                                                                                                    id: subtopic.topicMasterDetails?.id,
                                                                                                    topicName: subtopic.topicMasterDetails?.topicName
                                                                                                }]);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>

                                                                                            {/* <button className="btn btn-outline" type="button" onClick={() => {
                                                                                                showModal(subtopic.details)
                                                                                            }}><i class="fa fa-eye" ></i></button> */}

                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setVisible(!visible)
                                                                                                setModalData(subtopic.details)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === subtopic.id} onClick={() => deleteSubtopic(subtopic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Sub Topic Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subtopicList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionSubtopicMaster;